import { toJSON } from "@models/utils";
export var PaypalTransactionCaptureStatus;
(function (PaypalTransactionCaptureStatus) {
    PaypalTransactionCaptureStatus["COMPLETED"] = "COMPLETED";
    PaypalTransactionCaptureStatus["DENIED"] = "DENIED";
    PaypalTransactionCaptureStatus["PENDING"] = "PENDING";
    PaypalTransactionCaptureStatus["REFUNDED"] = "REFUNDED";
    PaypalTransactionCaptureStatus["REVERSED"] = "REVERSED";
    PaypalTransactionCaptureStatus["WAIVED"] = "WAIVED";
    PaypalTransactionCaptureStatus["INITIATED"] = "INITIATED";
    PaypalTransactionCaptureStatus["APPROVED"] = "APPROVED";
    PaypalTransactionCaptureStatus["CANCELLED"] = "CANCELLED";
    PaypalTransactionCaptureStatus["FAILED"] = "FAILED";
})(PaypalTransactionCaptureStatus || (PaypalTransactionCaptureStatus = {}));
export class PaypalTransaction {
    constructor(params) {
        this.id = params === null || params === void 0 ? void 0 : params.id;
        this.ticketId = params === null || params === void 0 ? void 0 : params.ticketId;
        this.priceId = params === null || params === void 0 ? void 0 : params.priceId;
        this.price = (params === null || params === void 0 ? void 0 : params.price) || 0;
        this.captureStatus =
            (params === null || params === void 0 ? void 0 : params.captureStatus) || PaypalTransactionCaptureStatus.INITIATED;
        this.refIds = (params === null || params === void 0 ? void 0 : params.refIds) || {};
        this.contactInfos = (params === null || params === void 0 ? void 0 : params.contactInfos) || [];
        this.emails = (params === null || params === void 0 ? void 0 : params.emails) || [];
        this.discountCodeId = (params === null || params === void 0 ? void 0 : params.discountCodeId) || "";
        this.createdAt = (params === null || params === void 0 ? void 0 : params.createdAt) || new Date().valueOf();
        this.updatedAt = (params === null || params === void 0 ? void 0 : params.updatedAt) || new Date().valueOf();
        this.quantity = (params === null || params === void 0 ? void 0 : params.quantity) || this.contactInfos.length;
        this.buyer = (params === null || params === void 0 ? void 0 : params.buyer) || "";
        this.walletAddress = (params === null || params === void 0 ? void 0 : params.walletAddress) || "";
        this.locale = (params === null || params === void 0 ? void 0 : params.locale) || "en";
        this.userId = params === null || params === void 0 ? void 0 : params.userId;
    }
    get json() {
        return toJSON(this);
    }
    get templateId() {
        return this.ticketId;
    }
    get buyerBuysForOneself() {
        return (this.contactInfos &&
            this.contactInfos.length > 0 &&
            this.contactInfos[0].emailAddress === this.buyer);
    }
    get buyerBuysForOthersOnly() {
        return (this.contactInfos &&
            this.contactInfos.length > 0 &&
            this.contactInfos[0].emailAddress !== this.buyer);
    }
}
